import { Icon } from '@fluentui/react';
import React from 'react';

export const fileLogos = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': (
    <Icon iconName="ExcelDocument" />
  ),
  '': <Icon iconName="PDF" />,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': (
    <Icon iconName="WordDocument" />
  ),
  '': <Icon iconName="PowerPointDocument" />,
  '': <Icon iconName="TextDocument" />,
  default: <Icon iconName="TextDocument" />
};
